import React, { useState } from 'react'
import { WithChildren, KTSVG } from '_metronic/helpers'

const MAX_VISIBILITY = 5

const CardCarousel: React.FC<
	WithChildren & { customActive?: number; setCustomActive?: (idx: number) => void }
> = ({ children, customActive, setCustomActive }) => {
	const count = React.Children.count(children)
	const [active, setActive] = useState(count > 0 ? Math.floor(count / 2) : 0)
	const isCustomActive = customActive !== undefined && setCustomActive !== undefined

	const currentActive = isCustomActive ? customActive : active
	const currentSetActive = isCustomActive ? setCustomActive : setActive

	return (
		<div className="d-flex align-items-center justify-content-center h-100">
			<div className="kumopack-card-carousel">
				{currentActive > 0 && (
					<button className="kumopack-nav left" onClick={() => currentSetActive(currentActive - 1)}>
						<KTSVG
							path="/media/icons/duotune/arrows/arr021.svg"
							className="transition-300 svg-icon-3x"
						/>
					</button>
				)}
				{React.Children.map(children, (child, i) => (
					<div
						className="kumopack-card-container"
						style={{
							// @ts-ignore
							'--active': i === currentActive ? 1 : 0,
							'--offset': (currentActive - i) / 3,
							'--direction': Math.sign(currentActive - i),
							'--abs-offset': Math.abs(currentActive - i) / 3,
							pointerEvents: currentActive === i ? 'auto' : 'none',
							display: Math.abs(currentActive - i) > MAX_VISIBILITY ? 'none' : 'flex',
						}}>
						{child}
					</div>
				))}
				{currentActive < count - 1 && (
					<button
						className="kumopack-nav right"
						onClick={() => currentSetActive(currentActive + 1)}>
						<KTSVG
							path="/media/icons/duotune/arrows/arr024.svg"
							className="transition-300 svg-icon-3x"
						/>
					</button>
				)}
			</div>
		</div>
	)
}

export default CardCarousel
